/** CSS cursor values used on web for the drawing overlay. */
export enum CanvasCursor {
  Default = 'default',
  Crosshair = 'crosshair',
  Text = 'text',
  Pointer = 'pointer',
  Move = 'move',
  Grab = 'grab',
  Grabbing = 'grabbing',
  NotAllowed = 'not-allowed',
  ResizeNwse = 'nwse-resize',
  ResizeNesw = 'nesw-resize',
  ResizeNs = 'ns-resize',
  ResizeEw = 'ew-resize',
}
